import { GOOGLE_TAG_MANAGER, TRACKER_CATEGORIES } from 'common/constants/thirdPartyTrackingManager';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const bootstrap = getBootstrap();
const isGoogleTagManagerEnabled = bootstrap.get('thirdPartyTrackingManager.isGoogleTagManagerEnabled');

const filterRestrictedTrackers = ({ trackerList, cookieConsentedCategories }) => {
    const restrictedTrackers = [];

    Object.entries(TRACKER_CATEGORIES).forEach(([category, trackers]) => {
        if (!cookieConsentedCategories.includes(category)) {
            restrictedTrackers.push(...trackers);
        }
    });

    if (!isGoogleTagManagerEnabled && !restrictedTrackers.includes(GOOGLE_TAG_MANAGER)) {
        restrictedTrackers.push(GOOGLE_TAG_MANAGER);
    }

    return restrictedTrackers.length
        ? trackerList.filter(({ tracker }) => !restrictedTrackers.includes(tracker))
        : trackerList;
};

export default filterRestrictedTrackers;
